import { SVGProps } from "react";

export default function StripeSuccessCheckIcon(
  props: SVGProps<SVGSVGElement>
) {
  const { height = 80, width = 80, fill = "#368759", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.6763 12.6625C31.4235 9.5031 35.4777 7.5 40 7.5C44.522 7.5 48.5761 9.50291 51.3233 12.662C55.5004 12.3702 59.784 13.8205 62.9821 17.0186C66.1801 20.2166 67.6305 24.5003 67.3386 28.6773C70.4974 31.4245 72.5 35.4783 72.5 40C72.5 44.5226 70.4966 48.577 67.3369 51.3242C67.6281 55.5006 66.1777 59.7834 62.9802 62.9809C59.7827 66.1783 55.5 67.6287 51.3236 67.3376C48.5764 70.4969 44.5222 72.5 40 72.5C35.478 72.5 31.424 70.4971 28.6768 67.3381C24.4997 67.6299 20.216 66.1796 17.0179 62.9815C13.8199 59.7835 12.3695 55.4998 12.6614 51.3227C9.50262 48.5755 7.5 44.5217 7.5 40C7.5 35.4781 9.50282 31.4241 12.6618 28.6769C12.3703 24.5002 13.8207 20.2169 17.0185 17.0191C20.2163 13.8213 24.4996 12.371 28.6763 12.6625ZM52.0343 33.9531C52.8369 32.8296 52.5766 31.2682 51.4531 30.4657C50.3296 29.6631 48.7682 29.9234 47.9657 31.0469L37.181 46.1455L31.7678 40.7322C30.7915 39.7559 29.2085 39.7559 28.2322 40.7322C27.2559 41.7085 27.2559 43.2915 28.2322 44.2678L35.7322 51.7678C36.2519 52.2874 36.9738 52.5521 37.7062 52.4915C38.4386 52.4309 39.1072 52.0511 39.5343 51.4531L52.0343 33.9531Z"
        fill={fill}
      />
    </svg>
  );
}
